import { captureException } from '@webtv/error-reporting-v2';
// 🚨 READ THIS BEFORE ADDING ADDITIONAL TRANSFORMERS 🚨
//
// The "builtin" transformers that this package ships from this file are meant to serve extremely broad, generic, STABLE use cases.
// Complex transformers should be kept in higher-level packages (which is why this package exports the types you see above).
// Examples of additional transformers that could be added here are: `toInteger`/`toFloat`/`toBigInt` or MAYBE `toRecord`
export var toBoolean = {
  serialize: function serialize(value) {
    try {
      return value === null ? null : String(value);
    } catch (e) {
      captureException(e);
      return null;
    }
  },
  deserialize: function deserialize(value) {
    try {
      return value === null ? null : value === 'true';
    } catch (e) {
      captureException(e);
      return null;
    }
  }
};